import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { DetailEditorPropsByYear } from '../types'
import { LivestockEditorSimple } from './LivestockEditorSimple'

export const LivestockEditor = ({ year, name = 'livestock', ...rest }: DetailEditorPropsByYear) => {
  const { t } = useTranslation('@cibo/landmanager/LivestockEditor')

  return (
    <Stack spacing={2}>
      <Typography>{t('cta', { year })}</Typography>
      <LivestockEditorSimple year={year} name={name} comfortable {...rest} />
    </Stack>
  )
}
